const DetermineIndexing = (
	pageIndexingRequested: boolean,
	env: Record<string, string>,
	preview: boolean,
	doNotIndex: boolean,
	domain: string
) => {
	// If domain (header) contains dev/stg/uat/preprod, return false and do not index
	const matches = /(uat|dev|stg|preprod)/.exec(domain || '');
	if (matches) {
		return false;
	}

	// Always noindex, nofollow if page is a preview
	if (preview) {
		return false;
	}

	// If app deems the whole site to be not indexed
	if (doNotIndex) {
		return false;
	}

	return pageIndexingRequested && env?.ENVIRONMENT_NAME === 'prod';
};

export default DetermineIndexing;
